export default "__VITE_ASSET__COY1pQMp__"